import { PodcastDetailPage } from '@/modules/support/components/podcast-detail/page';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(PodcastDetailPage);

export const roles: string[] = ['super-admin', 'supporter'];
export const path = '/support/podcast/:podcastId';
export const element = <AnimatedPage />